import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBolt, faChartLine, faFire } from '@fortawesome/free-solid-svg-icons'

import NMOption from './NMOption';
import FsdsaiOption from './FsdsaiOption';
import nextStartDate from '../../utils/nextStartDate';
import NextStartDate from '../../components/NextStartDate';
import Discount from './Discount';
import TopRank from './TopRank';

import './StepZero.scss';

const tracks = ['fswd', 'fewd', 'bewd'];

class StepZero extends React.Component {
  render() {
    return (
      <div className="bg-white" id="step-zero">
        <div className="container">
          <div className="row">
            <div className="col p-4">
              <div className="m-3">
                <h2 className="mb-4 message text-center">Invest In Yourself</h2>
                <p className='text-center message m-0'><b><FontAwesomeIcon icon={faBolt} transform={{ rotate: 5 }} /> Join the #{new nextStartDate().cohortNumber()} Cohort. Enroll for <NextStartDate /></b></p>

                <Discount rate={this.props.rate} />

                <p className="text-center text-muted m-0"><b>Pick an online program below</b></p>
              </div>

              <div className="d-flex flex-column flex-md-row flex-wrap align-items-center align-items-md-start justify-content-center">
                {
                  tracks.map((long_symbol, index) => (
                    <div key={index} className="h-100">
                      {long_symbol == 'fswd' && (<h3 className="text-center d-none d-md-block"><span className="badge badge-success px-3 py-2 rounded" style={{backgroundColor: "#1647fb"}}>Most Popular</span></h3>)}
                      {long_symbol !== 'fswd' && (<h3 className="text-center d-none d-md-block" style={{height: "33.8px"}}></h3>)}

                      <NMOption
                        history={this.props.history}
                        tracks={this.props.tracks}
                        track_long_symbol={long_symbol}
                        rate={this.props.rate}
                        most_popular={long_symbol == 'fswd' ? true : false}
                      />

                      {long_symbol == 'fswd' && (<FsdsaiOption
                        history={this.props.history}
                        tracks={this.props.tracks}
                        track_long_symbol={long_symbol}
                        rate={this.props.rate}
                        most_popular={long_symbol == 'fswd' ? true : false}
                        is_fsdsai={true}
                      />)}
                    </div>
                  ))
                }
              </div>

              <div className="m-3">
                <TopRank />

                <div className="pt-4 text-center">
                  <img width="40px" height="auto" className="ml-2 mr-2" src="/images/cards/visa.png"></img>
                  <img width="40px" height="auto" className="ml-2 mr-2" src="/images/cards/mastercard2.png"></img>
                  <img width="40px" height="auto" className="ml-2 mr-2" src="/images/cards/american_express.png"></img>
                  <img width="40px" height="auto" className="ml-2 mr-2" src="/images/cards/discover.png"></img>
                  <img width="40px" height="auto" className="ml-2 mr-2" src="/images/cards/jcb.png"></img>
                  <img width="40px" height="auto" className="ml-2 mr-2" src="/images/cards/wechatpay.png"></img>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default StepZero;
